import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { dualAuthGuard } from './auth/services/dual-auth.guard';

import { ContextResolverService } from '@core/core.module';
import { DefaultRouteComponent, ContextComponent } from '@navigation/navigation.module';

const routes: Routes = [
    {
        path: '',
        component: DefaultRouteComponent,
        resolve: {
            data: ContextResolverService
        },
        canActivate: [dualAuthGuard]
    },
    {
        path: ':clubId/court-sheet',
        component: ContextComponent,
        resolve: {
            data: ContextResolverService
        },
        canActivate: [dualAuthGuard],
        children: [
            {
                path: '',
                loadChildren: () => import('./court-sheet/court-sheet.module').then(m => m.CourtSheetModule)
            }
        ],
    },
    {
        path: ':clubId/court-events',
        component: ContextComponent,
        resolve: {
            data: ContextResolverService
        },
        canActivate: [dualAuthGuard],
        children: [
            {
                path: '',
                loadChildren: () => import('./court-events/court-events.module').then(m => m.CourtEventsModule)
            }
        ],
    },
    {
        path: ':clubId/court-management',
        component: ContextComponent,
        resolve: {
            data: ContextResolverService
        },
        canActivate: [dualAuthGuard],
        children: [
            {
                path: '',
                loadChildren: () => import('./court-management/court-management.module').then(m => m.CourtManagementModule)
            }
        ],
    },
    {
        path: 'rules-matrix',
        loadChildren: () => import('./rules-matrix/rules-matrix.module').then(m => m.RulesMatrixModule),
        canActivate: [dualAuthGuard],
    },
    {
        path: 'reports',
        loadChildren: () => import('./reports/reports.module').then(m => m.ReportsModule),
        canActivate: [dualAuthGuard],
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {
    onSameUrlNavigation: 'reload',
    scrollPositionRestoration: 'enabled',
})],
    exports: [RouterModule]
})
export class AppRoutingModule {}
